import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, ArrowRight, Lock } from "lucide-react";
import { apiClient } from "../lib/api";
import { BRAND } from "../lib/constants";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await apiClient.post("/admin/login", { email, password });
      localStorage.setItem("sfe_admin_token", res.data.token);
      localStorage.setItem("sfe_admin_email", res.data.email);
      toast.success("Welcome back.");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen bg-black flex items-center justify-center px-6 py-24 relative overflow-hidden"
    >
      <div className="absolute inset-0 hero-radial pointer-events-none" />
      <div className="relative w-full max-w-md">
        <div className="text-center mb-10">
          <Link to="/" className="inline-flex items-center gap-3" data-testid="admin-logo-link">
            <img src={BRAND.logo} alt="SFE" className="h-14 w-14 object-contain" />
          </Link>
          <div className="mt-5 text-[10px] tracking-[0.3em] text-[#E50914] uppercase">
            ⏤ Admin Portal
          </div>
          <h1 className="font-display text-3xl uppercase tracking-tight mt-3">
            Sign in to continue
          </h1>
        </div>

        <form
          onSubmit={submit}
          data-testid="admin-login-form"
          className="bg-[#0A0A0A] border border-zinc-800 p-8"
        >
          <div className="mb-5">
            <label className="text-[10px] uppercase tracking-[0.25em] text-zinc-500 mb-2 block font-semibold">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email-input"
              className="w-full bg-black border border-zinc-800 focus:border-[#E50914] focus:outline-none px-4 py-3.5 text-sm text-white"
              placeholder="admin@sfeblackcar.com"
              required
            />
          </div>
          <div className="mb-7">
            <label className="text-[10px] uppercase tracking-[0.25em] text-zinc-500 mb-2 block font-semibold">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input"
              className="w-full bg-black border border-zinc-800 focus:border-[#E50914] focus:outline-none px-4 py-3.5 text-sm text-white"
              placeholder="••••••••"
              required
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full bg-[#E50914] hover:bg-[#FF2A2A] disabled:opacity-60 text-white py-4 text-sm font-bold uppercase tracking-[0.25em] inline-flex items-center justify-center gap-3 transition-all hover:shadow-[0_0_24px_rgba(229,9,20,0.5)]"
          >
            {loading ? (
              <>
                <Loader2 className="w-4 h-4 animate-spin" /> Signing in...
              </>
            ) : (
              <>
                <Lock className="w-4 h-4" /> Sign In <ArrowRight className="w-4 h-4" />
              </>
            )}
          </button>
        </form>

        <Link
          to="/"
          className="block text-center mt-6 text-[10px] uppercase tracking-[0.25em] text-zinc-600 hover:text-zinc-300"
          data-testid="admin-back-home"
        >
          ← Back to site
        </Link>
      </div>
    </div>
  );
}
